import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/3d.png'


const _withScopeId = n => (_pushScopeId("data-v-6f08d998"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_5 = {
  key: 0,
  class: "goods-header"
}
const _hoisted_6 = { class: "left-contents" }
const _hoisted_7 = {
  key: 0,
  class: "right-contents"
}
const _hoisted_8 = { class: "title-box" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_11 = { class: "lable" }
const _hoisted_12 = { class: "contents-box" }
const _hoisted_13 = { class: "price" }
const _hoisted_14 = { class: "price-title" }
const _hoisted_15 = { class: "price-number" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_17 = {
  key: 1,
  class: "old-price"
}
const _hoisted_18 = { class: "old-price-title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_20 = { class: "old-price-num" }
const _hoisted_21 = { class: "price" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "型号", -1))
const _hoisted_23 = { class: "modle-no" }
const _hoisted_24 = {
  key: 0,
  class: "price"
}
const _hoisted_25 = { class: "buytips" }
const _hoisted_26 = { class: "price" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "浏览次数", -1))
const _hoisted_28 = { class: "clicknum" }
const _hoisted_29 = { class: "price" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "个人会员", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-shuangjiantou1" }, null, -1))
const _hoisted_32 = { class: "price" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "企业会员", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-shuangjiantou1" }, null, -1))
const _hoisted_35 = {
  key: 1,
  class: "price"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "showtips" }, "购买会员可享8折优惠！", -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "price" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "咨询服务", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-wenhao" }, null, -1))
const _hoisted_41 = { class: "practice" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 方案实践度 ", -1))
const _hoisted_43 = {
  key: 0,
  src: "/static/product/shijianxing1.png"
}
const _hoisted_44 = {
  key: 1,
  src: "/static/product/shijianxing2.png"
}
const _hoisted_45 = {
  key: 2,
  src: "/static/product/shijianxing.png"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-wenhao" }, null, -1))
const _hoisted_50 = {
  key: 0,
  class: "dongle"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "温馨提示", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-info" }, "该方案的识别软件包含加密狗需要邮寄！", -1))
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "info"
}
const _hoisted_55 = {
  key: 2,
  class: "info"
}
const _hoisted_56 = {
  key: 1,
  class: "right-contents"
}
const _hoisted_57 = { class: "right-contents-parts-left" }
const _hoisted_58 = { class: "title-box" }
const _hoisted_59 = { class: "title" }
const _hoisted_60 = {
  key: 0,
  src: _imports_0
}
const _hoisted_61 = { class: "lable" }
const _hoisted_62 = { class: "contents-box" }
const _hoisted_63 = { class: "price" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, " 价格 ", -1))
const _hoisted_65 = {
  key: 0,
  class: "clicknum"
}
const _hoisted_66 = {
  key: 1,
  class: "price-number-real"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-rmb" }, null, -1))
const _hoisted_68 = {
  key: 2,
  class: "old-price"
}
const _hoisted_69 = { class: "old-price-title" }
const _hoisted_70 = {
  key: 0,
  class: "price"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "产品品牌", -1))
const _hoisted_72 = { class: "clicknum" }
const _hoisted_73 = { class: "price" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "型号", -1))
const _hoisted_75 = { class: "clicknum" }
const _hoisted_76 = { class: "price" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "货期", -1))
const _hoisted_78 = { class: "clicknum" }
const _hoisted_79 = { class: "price" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "物流", -1))
const _hoisted_81 = { class: "clicknum" }
const _hoisted_82 = {
  key: 1,
  class: "price"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "支付方式", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clicknum" }, [
  /*#__PURE__*/_createElementVNode("span", null, "微信"),
  /*#__PURE__*/_createElementVNode("span", null, "支付宝"),
  /*#__PURE__*/_createElementVNode("span", null, "企业对公支付")
], -1))
const _hoisted_85 = [
  _hoisted_83,
  _hoisted_84
]
const _hoisted_86 = {
  key: 2,
  class: "price"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "合作方式", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clicknum" }, [
  /*#__PURE__*/_createElementVNode("span", null, "线下")
], -1))
const _hoisted_89 = [
  _hoisted_87,
  _hoisted_88
]
const _hoisted_90 = {
  key: 3,
  class: "price goods-nums"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-title price-title-caigou" }, "采购量", -1))
const _hoisted_92 = { class: "clicknum" }
const _hoisted_93 = {
  key: 0,
  class: "clicknum-stock"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "price" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "price-title" }, "温馨提示"),
  /*#__PURE__*/_createElementVNode("div", { class: "clicknum" }, " 图片仅供参考，不能作为选型和购买依据 ")
], -1))
const _hoisted_95 = {
  key: 0,
  class: "info"
}
const _hoisted_96 = {
  key: 1,
  class: "info"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-tips" }, "暂不支持在线交易", -1))
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = {
  key: 2,
  class: "info"
}
const _hoisted_100 = { class: "right-contents-parts-right" }
const _hoisted_101 = { class: "parts-right-contents" }
const _hoisted_102 = { class: "part-item parts-right-item" }
const _hoisted_103 = /*#__PURE__*/_createStaticVNode("<div class=\"part-item-ul\" data-v-6f08d998><p class=\"part-item-li\" data-v-6f08d998><i class=\"icon iconfont icon-guigeqiquan\" data-v-6f08d998></i><span data-v-6f08d998>规格齐全</span></p><p class=\"part-item-li\" data-v-6f08d998><i class=\"icon iconfont icon-pinzhibaozhang\" data-v-6f08d998></i><span data-v-6f08d998>品质保障</span></p><p class=\"part-item-li\" data-v-6f08d998><i class=\"icon iconfont icon-a-jisujiaoqi1\" data-v-6f08d998></i><span data-v-6f08d998>急速交期</span></p><p class=\"part-item-li\" data-v-6f08d998><i class=\"icon iconfont icon-liangdabaoyou\" data-v-6f08d998></i><span data-v-6f08d998>量大包邮</span></p></div>", 1)
const _hoisted_104 = { class: "part-item-serve" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "快速订购", -1))
const _hoisted_106 = { class: "item-serve-li" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-shouqiankefu" }, null, -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "售前客服", -1))
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = { class: "item-serve-li" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-shouhoufuwu" }, null, -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "售后客服", -1))
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = /*#__PURE__*/_createStaticVNode("<div class=\"item-serve-li\" data-v-6f08d998><i class=\"icon iconfont icon-phone1\" data-v-6f08d998></i><span class=\"nota\" data-v-6f08d998>电话：400-653-7789</span></div><div class=\"item-serve-li\" data-v-6f08d998><i class=\"icon iconfont icon-phone\" data-v-6f08d998></i><span class=\"nota\" data-v-6f08d998>手机：17695728690</span></div>", 2)
const _hoisted_116 = /*#__PURE__*/_createStaticVNode("<div class=\"part-item parts-right-item\" data-v-6f08d998><div class=\"part-item-serve\" data-v-6f08d998><div class=\"title\" data-v-6f08d998>服务须知</div><p class=\"title-li\" data-v-6f08d998> 1.统一发货，提供专人对接的优质快速售后服务 </p><p class=\"title-li\" data-v-6f08d998> 2.库存实时变化，具体发货时间以发货为准 </p></div></div>", 1)
const _hoisted_117 = { class: "goods-contents" }
const _hoisted_118 = { class: "left" }
const _hoisted_119 = {
  key: 0,
  class: "left-class"
}
const _hoisted_120 = { class: "left-hot" }
const _hoisted_121 = { class: "title" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-huore" }, null, -1))
const _hoisted_123 = { class: "list" }
const _hoisted_124 = { class: "item" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_126 = { class: "right" }
const _hoisted_127 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_CurrentAddress = _resolveComponent("CurrentAddress")!
  const _component_goods_swiper = _resolveComponent("goods-swiper")!
  const _component_GoodsCollection = _resolveComponent("GoodsCollection")!
  const _component_vip_list = _resolveComponent("vip-list")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Consultion = _resolveComponent("Consultion")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_goods_class = _resolveComponent("goods-class")!
  const _component_HatGoodsInfo = _resolveComponent("HatGoodsInfo")!
  const _component_DetailInfo = _resolveComponent("DetailInfo")!
  const _component_VideoInfo = _resolveComponent("VideoInfo")!
  const _component_ImgInfo = _resolveComponent("ImgInfo")!
  const _component_StructureInfo = _resolveComponent("StructureInfo")!
  const _component_DownInfo = _resolveComponent("DownInfo")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CurrentAddress, null, {
          address: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" > 商品详情")
          ]),
          _: 1
        })
      ]),
      (_ctx.goodsInfo.datas)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(["large", { 'large-parts': _ctx.goodsInfo.datas.is_real_goods == 1 }]),
              style: _normalizeStyle([
						{
							backgroundImage: 'url(' + _ctx.nowImgUrl + ')',
							backgroundPosition: `-${_ctx.position.x * 2}px -${_ctx.position.y * 2}px`,
						},
					])
            }, null, 6), [
              [_vShow, !_ctx.fisOutside]
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["left", { 'parts-left': _ctx.goodsInfo.datas.is_real_goods == 1 }])
            }, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.resetImg().tmepImgList.length > 0)
                  ? (_openBlock(), _createBlock(_component_goods_swiper, {
                      key: 0,
                      type: 1,
                      pics: _ctx.resetImg().tmepImg,
                      piclist: _ctx.resetImg().tmepImgList,
                      onSetPosition: _ctx.setPosition
                    }, null, 8, ["pics", "piclist", "onSetPosition"]))
                  : _createCommentVNode("", true),
                (_ctx.goodsInfo.datas.names)
                  ? (_openBlock(), _createBlock(_component_GoodsCollection, {
                      key: 1,
                      marginTop: 40,
                      names: _ctx.goodsInfo.datas.names,
                      id: _ctx.goodsInfo.datas.id,
                      store: _ctx.goodsInfo.datas.store,
                      goods: _ctx.goodsInfo.datas,
                      cid: _ctx.goodsInfo.datas.cid,
                      type: 
								_ctx.goodsInfo.datas.is_real_goods == 1 ? 4 : 1
							
                    }, null, 8, ["names", "id", "store", "goods", "cid", "type"]))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["right", { 'parts-right': _ctx.goodsInfo.datas.is_real_goods == 1 }])
            }, [
              (_ctx.goodsInfo.datas.is_real_goods == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, [
                        _createTextVNode(_toDisplayString(_ctx.goodsInfo.datas.names), 1),
                        _hoisted_10
                      ]),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.goodsInfo.datas.content), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.isActivity() ? "折扣价" : "价格"), 1),
                        _createElementVNode("span", _hoisted_15, [
                          _hoisted_16,
                          _createTextVNode(_toDisplayString(_ctx.isActivity()
											? Math.round(_ctx.goodsInfo.datas.activity_price)
											: Math.round(_ctx.goodsInfo.datas.price)), 1)
                        ]),
                        (_ctx.vipinfo.type > 0 && !_ctx.goodsInfo.datas.activity_price)
                          ? (_openBlock(), _createBlock(_component_vip_list, {
                              key: 0,
                              price: _ctx.goodsInfo.datas.price
                            }, null, 8, ["price"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.isActivity() ? "价格" : "原价"), 1),
                              _hoisted_19,
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.isActivity()
											? Math.round(_ctx.goodsInfo.datas.price)
											: Math.round(_ctx.goodsInfo.datas.original_price)), 1)
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.modleName), 1)
                      ]),
                      (_ctx.goodsInfo.datas.buy && _ctx.goodsInfo.datas.buy > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("p", _hoisted_25, [
                              _createTextVNode(" 该商品已购买。 "),
                              _createVNode(_component_router_link, {
                                to: {
											name: 'orderdown',
											params: {
												id: _ctx.goodsInfo.datas.orderId,
											},
										}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("去下载")
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.goodsInfo.datas.click), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("div", {
                          class: "vipinfo",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoUser()))
                        }, [
                          (_ctx.vipinfo.type == 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" 前往查看 ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" 前往获取 ")
                              ], 64)),
                          _hoisted_31
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("div", {
                          class: "vipinfo",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoUser('second')))
                        }, [
                          (_ctx.vipinfo.type == 2)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" 前往查看 ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" 前往获取 ")
                              ], 64)),
                          _hoisted_34
                        ])
                      ]),
                      (!(_ctx.isActivity() || _ctx.vipinfo.type > 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createVNode(_component_Consultion, {
                          price: _ctx.servicePice,
                          onChangStatus: _ctx.changStatus
                        }, null, 8, ["price", "onChangStatus"]),
                        _createVNode(_component_el_popover, {
                          placement: "top-start",
                          width: 200,
                          trigger: "hover",
                          content: "咨询服务是设纪元为您提供的个性化的服务体验，将服务产品化，为您提供设计方案的相关资讯服务，由设纪元专业机械工程师为您答疑解惑，帮助您更好的理解和使用该方案。"
                        }, {
                          reference: _withCtx(() => [
                            _hoisted_40
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        (_ctx.goodsInfo.datas.real == 2)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_43))
                          : (_ctx.goodsInfo.datas.real == 3)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_44))
                            : (_openBlock(), _createElementBlock("img", _hoisted_45)),
                        _createVNode(_component_el_popover, {
                          placement: "top-start",
                          width: 300,
                          trigger: "hover"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 方案实践度分为："),
                            _hoisted_46,
                            _createTextVNode(" 概念型（创意作品，方案不可实践）"),
                            _hoisted_47,
                            _createTextVNode(" 未实践型（方案可实践，但尚未实际应用）"),
                            _hoisted_48,
                            _createTextVNode(" 实践型（方案已实际应用过） ")
                          ]),
                          reference: _withCtx(() => [
                            _hoisted_49
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (
								_ctx.goodsInfo.datas.is_send == 2 &&
								_ctx.goodsInfo.datas.is_real_goods == 0
							)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_50, _hoisted_53))
                      : _createCommentVNode("", true),
                    (
								_ctx.goodsInfo.datas.buy &&
								_ctx.goodsInfo.datas.buy > 0 &&
								_ctx.goodsInfo.datas.is_real_goods == 0
							)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buyDown())),
                            round: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("立即下载")
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buyNow())),
                            round: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("立即购买")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            type: "info",
                            round: "",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addCart()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("加入购物车")
                            ]),
                            _: 1
                          })
                        ]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("p", _hoisted_59, [
                          _createTextVNode(_toDisplayString(_ctx.goodsInfo.datas.names), 1),
                          (_ctx.goodsInfo.datas.is_real_goods == 0)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_60))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.goodsInfo.datas.content), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          (
											_ctx.goodsInfo.datas.is_real_goods == 1 &&
											_ctx.goodsInfo.datas.stock - _ctx.goodsInfo.datas.minimum < 0
										)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                _createElementVNode("a", {
                                  href: "javascript:;",
                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.shouqiankefu && _ctx.shouqiankefu(...args)))
                                }, "咨询客服")
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_66, [
                                _hoisted_67,
                                _createTextVNode(_toDisplayString(_ctx.showPrice(_ctx.goodsInfo.datas.price, 1)), 1)
                              ])),
                          (
											_ctx.goodsInfo.datas.is_real_goods == 1 &&
											!(_ctx.goodsInfo.datas.stock - _ctx.goodsInfo.datas.minimum < 0)
										)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_68, [
                                _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.goodsInfo.datas.minimum) + _toDisplayString(_ctx.goodsInfo.datas.goods_unit) + "起批 ", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.goodsInfo.datas.brand != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                              _hoisted_71,
                              _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.goodsInfo.datas.brand), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.modleName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _hoisted_77,
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.goodsInfo.datas.delivery) + "天发货", 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.goodsInfo.datas.is_return == 0
												? "不支持7天无理由退货"
												: "支持7天无理由退货"), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _hoisted_80,
                          _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.goodsInfo.datas.send_msg), 1)
                        ]),
                        (
										_ctx.goodsInfo.datas.is_real_goods == 1 &&
										!(_ctx.goodsInfo.datas.stock - _ctx.goodsInfo.datas.minimum < 0)
									)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_85))
                          : _createCommentVNode("", true),
                        (
										_ctx.goodsInfo.datas.is_real_goods == 1 &&
										_ctx.goodsInfo.datas.stock - _ctx.goodsInfo.datas.minimum < 0
									)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, _hoisted_89))
                          : _createCommentVNode("", true),
                        (
										_ctx.goodsInfo.datas.is_real_goods == 1 &&
										!(_ctx.goodsInfo.datas.stock - _ctx.goodsInfo.datas.minimum < 0)
									)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                              _hoisted_91,
                              _createElementVNode("div", _hoisted_92, [
                                _withDirectives(_createVNode(_component_el_input_number, {
                                  modelValue: _ctx.goodsNum,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.goodsNum) = $event)),
                                  min: 
												_ctx.goodsInfo.datas.stock - _ctx.goodsInfo.datas.minimum >= 0
													? _ctx.goodsInfo.datas.minimum
													: 0
											,
                                  max: _ctx.goodsInfo.datas.stock
                                }, null, 8, ["modelValue", "min", "max"]), [
                                  [_vShow, _ctx.fisOutside]
                                ]),
                                (
												_ctx.goodsInfo.datas.stock - _ctx.goodsInfo.datas.minimum >= 0
											)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_93, "库存 " + _toDisplayString(_ctx.goodsInfo.datas.stock), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_94
                      ]),
                      (
									_ctx.goodsInfo.datas.buy &&
									_ctx.goodsInfo.datas.buy > 0 &&
									_ctx.goodsInfo.datas.is_real_goods == 0
								)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.buyDown())),
                              round: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("立即下载")
                              ]),
                              _: 1
                            })
                          ]))
                        : (
									_ctx.goodsInfo.datas.is_real_goods == 1 &&
									_ctx.goodsInfo.datas.stock - _ctx.goodsInfo.datas.minimum < 0
								)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, _hoisted_98))
                          : (_openBlock(), _createElementBlock("div", _hoisted_99, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.buyNow())),
                                round: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("立即购买")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                type: "info",
                                round: "",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addCart()))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("加入采购车")
                                ]),
                                _: 1
                              })
                            ]))
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          _hoisted_103,
                          _createElementVNode("div", _hoisted_104, [
                            _hoisted_105,
                            _createElementVNode("div", _hoisted_106, [
                              _hoisted_107,
                              _createElementVNode("a", {
                                href: "javascript:;",
                                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.shouqiankefu && _ctx.shouqiankefu(...args)))
                              }, _hoisted_109)
                            ]),
                            _createElementVNode("div", _hoisted_110, [
                              _hoisted_111,
                              _createElementVNode("a", {
                                href: "javascript:;",
                                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.shouhoukefu && _ctx.shouhoukefu(...args)))
                              }, _hoisted_113)
                            ]),
                            _hoisted_114
                          ])
                        ]),
                        _hoisted_116
                      ])
                    ])
                  ]))
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_117, [
        _createElementVNode("div", _hoisted_118, [
          (_ctx.goodsInfo.datas.is_real_goods == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                _createVNode(_component_goods_class)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _hoisted_122,
              _createTextVNode(" " + _toDisplayString(_ctx.goodsInfo.datas.is_real_goods == 1 ? "热销推荐" : "方案热销"), 1)
            ]),
            _createElementVNode("div", _hoisted_123, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hotgoodslite.datas.data, (goods, index) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_124, [
                  _createVNode(_component_HatGoodsInfo, {
                    bodyWidth: 220,
                    contentsWidth: 200,
                    isRealGoods: _ctx.goodsInfo.datas.is_real_goods,
                    goods: goods
                  }, null, 8, ["isRealGoods", "goods"])
                ]))
              }), 256)),
              _hoisted_125
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_126, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodsInfo.datas.source, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass({ active: _ctx.active == index }),
                onClick: ($event: any) => (_ctx.toActive(index))
              }, _toDisplayString(item.title), 11, _hoisted_127))
            }), 256)),
            (_ctx.goodsInfo.datas.is_real_goods == 0)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass({ active: _ctx.active == 10 }),
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toActive(10)))
                }, " 详情整合下载 ", 2))
              : _createCommentVNode("", true)
          ]),
          (_ctx.goodsInfo.datas && _ctx.goodsInfo.datas.source)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.goodsInfo.datas.source, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (
									_ctx.active == index &&
									(item.title == '方案介绍' || item.title == '产品详情')
								)
                    ? (_openBlock(), _createBlock(_component_DetailInfo, {
                        key: 0,
                        goodsDetail: item,
                        isRealGoods: _ctx.goodsInfo.datas.is_real_goods
                      }, null, 8, ["goodsDetail", "isRealGoods"]))
                    : _createCommentVNode("", true),
                  (_ctx.active == index && item.title == '应用视频')
                    ? (_openBlock(), _createBlock(_component_VideoInfo, {
                        key: 1,
                        goodsDetail: item
                      }, null, 8, ["goodsDetail"]))
                    : _createCommentVNode("", true),
                  (
									_ctx.active == index &&
									(item.title == '结构图+尺寸图' ||
										item.title == '尺寸图' ||
										item.title == '构造图')
								)
                    ? (_openBlock(), _createBlock(_component_ImgInfo, {
                        key: 2,
                        goodsDetail: item
                      }, null, 8, ["goodsDetail"]))
                    : _createCommentVNode("", true),
                  (
									(_ctx.active == index && item.title == '气路原理图') ||
									(_ctx.active == index && item.title == '电气布局图')
								)
                    ? (_openBlock(), _createBlock(_component_ImgInfo, {
                        key: 3,
                        goodsDetail: item
                      }, null, 8, ["goodsDetail"]))
                    : _createCommentVNode("", true),
                  (
									_ctx.active == index && item.title == '文件结构'
								)
                    ? (_openBlock(), _createBlock(_component_StructureInfo, {
                        key: 4,
                        goodsDetail: item,
                        goodsModel: _ctx.modleName
                      }, null, 8, ["goodsDetail", "goodsModel"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            : _createCommentVNode("", true),
          (_ctx.active == 10)
            ? (_openBlock(), _createBlock(_component_DownInfo, {
                key: 1,
                goodsModel: _ctx.modleName,
                DownUrl: _ctx.DownUrl
              }, null, 8, ["goodsModel", "DownUrl"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_html_footer)
  ]))
}